<template>
  <v-dialog v-model="show" persistent max-width="600px">
    <v-card class="mb-0">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Agregar Saldo Deudor</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-4">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
          <v-row dense>
            <v-col cols="12">
              <v-alert color="info" outlined dense>
                Registrar un nuevo saldo deudor para el jugador
              </v-alert>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="jugadorSeleccionado"
                prepend-icon="mdi-account"
                label="Jugador *"
                readonly
                :rules="requiredRules"
                dense
                @click="abrirBuscarJugador"
              >
                <template v-slot:append>
                  <v-btn icon small @click="abrirBuscarJugador">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="monto"
                prepend-icon="mdi-currency-usd"
                label="Monto deudor *"
                :rules="montoRules"
                @keypress="onlyNumber"
                @blur="toFixed"
                dense
                maxlength="10"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-textarea
                v-model="observaciones"
                prepend-icon="mdi-note-text"
                label="Observaciones"
                rows="2"
                dense
                maxlength="200"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="grey lighten-1" @click.stop="show = false">
          Cancelar
        </v-btn>
        <v-btn
          color="error"
          :disabled="!valid"
          @click.stop="agregarSaldoDeudor"
        >
          Registrar Deuda
        </v-btn>
      </v-card-actions>
    </v-card>
    <BuscarJugadorTurno
      :visible="showBuscarJugador"
      @close="cierraBuscarJugador"
      @seleccionarPaciente="seleccionarJugador"
    ></BuscarJugadorTurno>
  </v-dialog>
</template>

<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";
import BuscarJugadorTurno from "../Turnos/BuscarJugadorTurno.vue";

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    BuscarJugadorTurno,
  },
  data() {
    return {
      valid: false,
      lazy: false,
      jugadorSeleccionado: "",
      idPaciente: null,
      monto: null,
      observaciones: "",
      showBuscarJugador: false,
      requiredRules: [(v) => !!v || "Dato obligatorio"],
      montoRules: [
        (v) => !!v || "Dato obligatorio",
        (v) => parseFloat(v) > 0 || "El monto debe ser mayor a 0",
      ],
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarModels();
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    abrirBuscarJugador() {
      this.showBuscarJugador = true;
    },
    cierraBuscarJugador() {
      this.showBuscarJugador = false;
    },
    seleccionarJugador(jugador) {
      this.idPaciente = jugador.idpaciente;
      this.jugadorSeleccionado = `${jugador.apellidos}, ${jugador.nombres}`;
      this.showBuscarJugador = false;
    },
    toFixed() {
      if (isNaN(parseFloat(this.monto)))
        this.monto = parseFloat(0.0).toFixed(2);
      else this.monto = parseFloat(this.monto).toFixed(2);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        $event.preventDefault();
      }
    },
    vaciarModels() {
      this.jugadorSeleccionado = "";
      this.idPaciente = null;
      this.monto = null;
      this.observaciones = "";
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    agregarSaldoDeudor() {
      this.$swal({
        title: "Agregar Saldo Deudor",
        text: "¿Desea registrar este saldo deudor para el jugador?",
        icon: "warning",
        type: "warning",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datos = {
            idJugador: this.idPaciente,
            importe: parseFloat(this.monto),
            observaciones: this.observaciones,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          };
          let self = this;
          axios
            .post("/Caja/AgregarSaldoDeudor", datos)
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Saldo deudor registrado exitosamente.",
                vm: self,
                timer: 2000,
              });
              self.vaciarModels();
              self.$emit("agregado");
              self.show = false;
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "No se pudo registrar el saldo deudor.",
                vm: this,
                timer: 2000,
              });
            });
        }
      });
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
  },
};
</script>
